import React, { useState, useEffect, useRef } from 'react';
import CommonNav from './CommonNav'
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import SubDropdown from './SubDropdown';
import GroupsDropdown from './GroupsDropdown';
//import MultiSelectSub from './MultiSelectSub';
import SubstituteGroupsViewer from './SubstituteGroupsViewer';
import { Card } from 'primereact/card';
import subSchedule from '../mock/subschedulelist.json';
import { Button } from 'primereact/button';
import { ListBox } from 'primereact/listbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Endpoints } from "../constants/env/middletier";

import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { FloatLabel } from 'primereact/floatlabel';
import { Dialog } from 'primereact/dialog';
import { useKeycloak } from "@react-keycloak/web";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from "react-router-dom";


function ScheduleSub() {
    const [date, setDate] = useState('');
    const [dates, setDates] = useState([]);
    const [selectedSub, setSelectedSub] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [disabledDates, setDisabledDates] = useState(null);
    const [filteredById, setFilteredById] = useState([]);
    const [message, setMessage] = useState('');
    const [subPhoneNumbers, setSubPhoneNumbers] = useState([]);
    const [selectedSubs, setSelectedSubs] = useState([]);
    const [result, setResult] = useState([]);
    const stepperRef = useRef(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [description, setDescription] = useState('');
    const [notes, setNotes] = useState('');
    const [editNotesMode, setEditNotesMode] = useState(true);
    const [editDescriptionMode, setEditDescriptionMode] = useState(false);

    const { keycloak, initialized } = useKeycloak();
    console.log("Authenticated:", keycloak.authenticated);
    console.log("Token:", keycloak.token);
    console.log("Initialized:", initialized);
    const userId = keycloak.tokenParsed.sub;
    const userFullName = keycloak.tokenParsed.name;
    const userSchoolId = keycloak.tokenParsed.school_id;
    const userSubjects = keycloak.tokenParsed.subjects;

    const userPhoneNumber =
        keycloak?.tokenParsed?.phone_number?.replace(/\D/g, "");

    const [showMessageSent, setShowMessageSent] = useState(false);
    const navigate = useNavigate();

    console.log("userPhoneNumber:", userPhoneNumber);
    console.log("User ID:", userId);
    console.log("Token parsed:");
    console.log(keycloak.tokenParsed);

    if (!initialized) {
        return <div>Loading Keycloak...</div>;
    }

    if (!keycloak.authenticated) {
        return (
            <div>
                <p>Please log in to access this page.</p>
                <button onClick={() => keycloak.login()}>Login</button>
            </div>
        );
    }


    const fetchUserInfo = async () => {
        if (!keycloak?.token) return null;

        const response = await fetch(
        `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/userinfo`,
        {
            headers: {
                Authorization: `Bearer ${keycloak.token}`,
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch user info");
        }

        return await response.json();
    };



    const handleChildData = (data) => {
        const subPhoneNumbersMapped = data.map((teacher) => (teacher.phone));
        console.log(subPhoneNumbersMapped);
        setSubPhoneNumbers(subPhoneNumbersMapped);
        setSelectedSubs(data);
        console.log("Setting data");
        console.log(subPhoneNumbersMapped);
    };

    const handleGroupsDropdownChange = (data) => {
        console.log("Setting group dropdown");
        console.log(data);
        setSelectedGroup(data.id);
    };

    const handleSubChange = (sub) => {
        setSelectedSub(sub);
        const filteredBySub = subSchedule.filter(item => item.id === sub?.id.toString());
        setFilteredById(filteredBySub);
    };

    const handleGetPhoneNumbers = () => {
        console.log("Getting phone numbers");
        console.log(subPhoneNumbers);
    };

    const handleLogout = () => {
        keycloak.logout({
            redirectUri: window.location.origin
        });
    };

    const handleCalendarChange = (d) => {
        const value = d.value;
        setDates(value);
        console.log("Getting dates 1");
        console.log(value);


        // When range has both start and end dates → close calendar
        if (value && value.length === 2 && value[0] && value[1]) {
            setCalendarVisible(false);
        }


    };

    const handleGetAvailableSubs = async () => {

        console.log("Getting dates 2");

        const format = (date) => date?.toISOString().split("T")[0];

        const start = format(dates?.[0]); // "2025-11-01"
        const end = format(dates?.[1]);   // "2025-11-15"



//        const url = 'http://localhost:8080/substitutes/available?start=${start}&end=${end}';

        console.log("Calling:");
        try {
            const response = await fetch(Endpoints["getavailablesubs"] + `?start=${start}&end=${end}&groupId=${selectedGroup}`, {
                method: "GET"
            });
            if (!response.ok) throw new Error("Bad response");
            const data = await response.json();
            setResult(data);
            setSelectedSubs(data);
            console.log(data);
        } catch (err) {
            console.error(err);
        }

        const userinfo = await fetchUserInfo();

        console.log("userinfo");
        console.log(userinfo);

        console.log(start);
        console.log(end);
        stepperRef.current.nextCallback();
    };





    const handleSendRequests = async () => {
        console.log("handleSendRequests");

        console.log(selectedSubs);
        selectedSubs.forEach((sub, index) => {
            sub.phone = sub.phone.replace(/\D/g, "");
            console.log(`Sub at index ${index}: ${sub.phone}`);
        });
        const storedUser = JSON.parse(localStorage.getItem("user"));
        console.log(storedUser);
//    const userPhoneNumber =
//        keycloak?.tokenParsed?.phone_number?.replace(/\D/g, "");


        const messageAndCreateJob = {
            "subs": selectedSubs,
            "subJobRequested": {
                "teacherId": userId,
                "teacherFullName": userFullName,
                "teacherPhoneNumber": userPhoneNumber,
                "startDate": dates[0],
                "endDate": dates[1],
                "description": description,
                "notes": notes,
                "subjectId": 2,
                "status": "pending",
                "schoolId": userSchoolId,
            },
            "jobDetails": userSubjects
        };
        console.log(messageAndCreateJob);


        try {
          const response = await fetch(Endpoints["messageandcreatejob"], {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(messageAndCreateJob),
          });

          const result = await response.json();
          console.log("Success:", result);
        } catch (error) {
          console.error("Error sending messages:", error);
        } finally {
            setShowMessageSent(true);
        }
    };



    const data_table_header = (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-xl text-900 font-bold">Available Subs &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Button label="Expand" icon="pi pi-external-link" severity="info" text rounded iconPos="right" onClick={() => setDialogVisible(true)} />
        </div>
    );


    const data_table_footer = (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <Button label="Send Request" onClick={handleSendRequests} icon="pi pi-send" rounded iconPos="right" />
        </div>
    );


    const dateTemplate = (dateMeta) => {
        const isDisabled = disabledDates.some(
            d =>
                d.getFullYear() === dateMeta.year &&
                d.getMonth() === dateMeta.month &&
                d.getDate() === dateMeta.day
        );

        return (
            <span style={ isDisabled ? { color: "red" } : {} }>
                {dateMeta.day}
            </span>
            );
    };

    const handleRequestComplete = () => {
        if (!showMessageSent)
            return;

        console.log("navigate");
        console.log(navigate);
        navigate("/viewMyJobs");
//        setShowMessageSent(false);

    };

    const showMessageSentfooterContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={handleRequestComplete} autoFocus />
        </div>
    );


//                                    <div className="flex gap-3">
//
//                                        {!editDescriptionMode && <Button onClick={() => setEditDescriptionMode(!editDescriptionMode)}
//                                        icon="pi pi-user-edit" text>&nbsp;Add Description</Button>}
//
//                                        {editDescriptionMode && <FloatLabel>
//                                            <InputTextarea id="description" autoResize maxLength={255} value={description} onChange={(e) => setDescription(e.target.value)} rows={5} cols={50} />
//                                            <label htmlFor="description">Description</label>
//                                        </FloatLabel>}
//                                    </div>




    return (
    <>
        <CommonNav></CommonNav>
        <br />
        <br />
<div className="card flex justify-content-center">
        <Stepper ref={stepperRef} style={{ flexBasis: '35rem' }}>
            <StepperPanel header="Select Date(s)">
                <div className="flex flex-column">
                    <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium"
                    style={{ minHeight: "500px" }}>
                        <div>
                            <FloatLabel>
                                <Calendar inputId="sub_dates_calendar" inline onChange={handleCalendarChange}
                                  value={dates} selectionMode="range" visible={calendarVisible}
                                  readOnlyInput onVisibleChange={(e) => setCalendarVisible(e.visible)}
                                />
                                <label htmlFor="sub_dates_calendar">Select Day(s) You Need a Sub</label>
                            </FloatLabel>
                       </div>
                   </div>
                </div>
                <div className="flex pt-4 justify-content-end">
                    <Button label="Next" disabled={dates.length < 2} icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                </div>
            </StepperPanel>
            <StepperPanel header="Select Group">
                <div className="flex flex-column h-12rem">
                    <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                        <GroupsDropdown onGetGroup={handleGroupsDropdownChange} />
                    </div>
                </div>
                <div className="flex pt-4 justify-content-between">
                    <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />
                    <Button label="List Available Subs" disabled={selectedGroup === null || dates.length < 2 || dates[1] === null} icon="pi pi-arrow-right" iconPos="right" onClick={handleGetAvailableSubs} />
                </div>
            </StepperPanel>
            <StepperPanel header="Add Notes">
                <div className="flex flex-column">
                    <div className="border-2 border-dashed surface-border border-round surface-ground flex justify-content-center align-items-center font-medium"
                    style={{ minHeight: "400px" }}>
                        {result && result.length > 0 && (
                        <div className="card flex flex-wrap justify-content-center gap-3">


                            <div className="flex flex-column align-items-center gap-5 ">
                                <div className="flex flex-column gap-5 ">
                                    <div className="flex gap-3">
                                    </div>
                                    <div className="flex gap-3">
                                        {!editNotesMode && <Button onClick={() => setEditNotesMode(!editNotesMode)} icon="pi pi-user-edit" text>&nbsp;Add Notes</Button>}
                                        {editNotesMode && <FloatLabel>
                                            <InputTextarea id="notes" autoResize value={notes} maxLength={255} onChange={(e) => setNotes(e.target.value)} rows={5} cols={50} />
                                            <label htmlFor="notes">Notes for Substitute</label>
                                        </FloatLabel>}
                                    </div>
                                </div>
                            </div>





                          <DataTable value={result} selectionMode={null} selection={selectedSubs}
                           header={data_table_header} footer={data_table_footer}
                           onSelectionChange={(e) => setSelectedSubs(e.value)}
                               scrollable scrollHeight="250px" dataKey="id">

                              <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                              <Column field="fullName" header="Name"></Column>
                              <Column field="phone" header="Phone"></Column>
                          </DataTable>
                        </div>
                        )}
                        <br />
                    </div>
                </div>
                <div className="flex pt-4 justify-content-start">
                    <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />
                </div>
            </StepperPanel>
        </Stepper>
    </div>

    <div className="card">
        <Dialog header="Available Substitutes" visible={dialogVisible} style={{ width: '75vw' }} maximizable
                modal contentStyle={{ height: '300px' }} onHide={() => setDialogVisible(false)}>
            <DataTable value={result} selectionMode={null} selection={selectedSubs}
                onSelectionChange={(e) => setSelectedSubs(e.value)}
                dataKey="id"
             scrollable scrollHeight="flex" tableStyle={{ minWidth: '50rem' }}>

              <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
              <Column field="fullName" header="Name"></Column>
              <Column field="phone" header="Phone"></Column>

            </DataTable>
        </Dialog>

        <Dialog header="Success" footer={showMessageSentfooterContent} visible={showMessageSent} style={{ width: '25vw' }} onHide={handleRequestComplete}>
            <p className="m-0">
                Request has been sent
            </p>
        </Dialog>
    </div>


    </>
    );
}

export default ScheduleSub;